<template>
    <Container type="card-full" drankColor >
      <div class="con">
        <el-tabs v-model="activeName" type="card"  :before-leave="leaveTab">
          <el-tab-pane label="评审信息录入" name="zjxx">
              <div class="view-container">
                <el-form :model="pexpertInfo" ref="ruleForm" label-position="right" class="mainfrom">
                    <div class="from_input">
                      <div class="row">
                        <el-form-item class="from-value" label="评审号:" prop="pexpertname" verify>
                          {{ this.$store.getters.expertLoginUser.pexpertlogincode }}
                        </el-form-item>
                      </div>
                      <div class="row">
                        <el-form-item label="身份证号码" placeholder="请输入身份证号码"  prop="pexpertidcode" verify>
                          <el-input v-model="pexpertInfo.pexpertidcode" :maxlength="30" @blur="onBlurCode" show-word-limit :disabled="disable"></el-input>
                        </el-form-item>
                      </div>
                      <div class="row">
                        <el-form-item label="姓名" placeholder="请输入姓名" prop="pexpertname" verify>
                          <el-input v-model="pexpertInfo.pexpertname" :maxlength="20" show-word-limit :disabled="disable"></el-input>
                        </el-form-item>
                      </div>
                      <div class="row">
                        <el-form-item label="手机号码" prop="pexpertmobile" :verify="validateProjectcode" placeholder="请输入内手机号" phone error-message="请输入正确的手机号">
                          <el-input v-model="pexpertInfo.pexpertmobile" :maxlength="20" show-word-limit :disabled="disable"></el-input>
                        </el-form-item>
                      </div>
                      <div class="row">
                        <el-form-item label="工作单位" placeholder="请输入工作单位" prop="pexpertemployer" verify>
                          <el-input v-model="pexpertInfo.pexpertemployer" :maxlength="225" show-word-limit :disabled="disable"></el-input>
                        </el-form-item>
                      </div>
                      <div class="row">
                        <el-form-item label="职称/职务" placeholder="请输入职称/职务" prop="pexpertposition">
                          <el-input v-model="pexpertInfo.pexpertposition" :maxlength="100" show-word-limit :disabled="disable"></el-input>
                        </el-form-item>
                      </div>
                      <div class="row">
                        <el-form-item label=" " verify>
                          <el-button type='primary' @click="saveExpertInfo" v-if="!disable">保存</el-button>
                        </el-form-item>
                      </div>
                    </div>
                </el-form>
              </div>
          </el-tab-pane>
          <el-tab-pane lazy label="评审人列表" name="pslb">
              <span @click="clickRefresh" style="color:blue;font-size:13px;cursor: pointer;">【点击刷新】</span>
              <vggrid :list="pxertlist" tableheight="600" flexname="" :cols="cols"
                      :showfooter="false" :showPage="false" :resizable="true"
                      :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
              >
              </vggrid>
          </el-tab-pane>
        </el-tabs>
      </div>
    </Container>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  const SUCCESS = 1
  export default {
    name: 'pExpertIndex',
    components: {vggrid},
    mixins: [common],
    data () {
      return {
        project: {},
        pexpertInfo:{},
        pxertlist: [],
        btnLoading: false,
        model: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols:[
          {field: 'pexpertlogincode', fieldtype: 'I', title: '评审号', calculExpr: ''},
          {field: 'pexpertname', fieldtype: 'C', title: '姓名', calculExpr: ''},
          {field: 'pexpertmobile', fieldtype: 'I', title: '手机', calculExpr: ''},
          {field: 'pexpertidcode', fieldtype: 'T', title: '身份证', calculExpr: ''},
          {field: 'pexpertemployer', fieldtype: 'T', title: '工作单位', calculExpr: ''},
          {field: 'pexpertposition', fieldtype: 'T', title: '职称/职务', calculExpr: ''},
          // {field: 'pexperttypeCN', fieldtype: 'T', title: '来源', calculExpr: ''},
          {field: 'pexpertroletypeCN', fieldtype: 'T', title: '评审角色', calculExpr: ''},
          {field: 'pexpertStatus', fieldtype: 'T', title: '状态', calculExpr: ''}
        ],
        disable:false,
        activeName: 'zjxx',
      }
    },
    created () {
      this.getModel()
    },
    activated(){
      this.getPexertInfo()
    },
    methods: {
      async onBlurCode (e) {
       const value = e.target.value
       if (value !== null && value !== '' && value.trim !== '') {
          let data = await request({
            method: 'get',
            url: 'expert/getPexpertByCode',
            params: {pexpertidcode: value, pexpertid: this.$store.getters.expertLoginUser.pexpertid}
          })
          if (data) {
            this.pexpertInfo.pexpertname = data.pexpertname
            this.pexpertInfo.pexpertmobile = data.pexpertmobile
            this.pexpertInfo.pexpertemployer = data.pexpertemployer
            this.pexpertInfo.pexpertposition = data.pexpertposition
          }
       }
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
      },
      validateProjectcode(rul, val, callback) {
        this.pexpertInfo.pexpertmobile = _.trim(val)
        this.validateData('手机号码不能重复','pexpertrec','pexpertid','pexpertmobile','pexpertprojectid', val, callback)
      },
      validateData (msg,tablename,fieldid,checkfield, fieldkey1, checkval,callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {
                  tablename,
                  fieldid,
                  checkfield,
                  checkval: this.pexpertInfo[checkfield],
                  id: this.pexpertInfo.pexpertid,
                  fieldkey1,
                  fieldkeyval1:this.pexpertInfo.pexpertprojectid
                }
        }).then (res => {
          res === SUCCESS ? callback(Error(msg)) : callback()
        })
      },
      async getPexertInfo () {
        let res = await request({
          method: 'get',
          url: 'expert/getPexertInfo',
          params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
        })
        // if(res.pexpertmobile){
        //   this.disable = true
        // }
        this.pexpertInfo = res
      },
      leaveTab(activeName, oldActiveName) {
        if(activeName==='pslb') {
          this.getPerctList()
        }
      },
      async getPageList () {
        this.loading = true
      },
      async cellClick (row) {
        this.model = row
      },
      async viewProject(row) {
        this.model = row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async saveExpertInfo(){
        this.loading = true
        this.submitForm('ruleForm').then(async() => {
            let res = await request({
                method: 'post',
                url: 'expert/saveExpertInfo',
                data: {pexpertid: this.$store.getters.expertLoginUser.pexpertid,pexpertInfo:this.pexpertInfo}
            })
            if(res.issuccess === 1){
              this.$message.success('保存成功')
              this.$store.commit('getPexertInfo');
              return
            }
        }).catch((e) => {
            console.log('=====e',e);
        })

        this.loading = false
      },
      async getPerctList(){
        this.loading = true
        let res = await request({
            method: 'get',
            url: 'expert/getPerctList',
            params: {pexpertprojectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        res.forEach(e => {
          e.pexperttypeCN = Number(e.pexperttype) === 1?'采购人':'评审人'
          e.pexpertroletypeCN = Number(e.pexpertroletype) === 1?'组长':'组员'
          e.pexpertStatus = e.pexpertmobile?'就绪':'准备'
        });
        this.pxertlist = res
        this.loading = false
      },
      async clickRefresh(){
        await this.getPerctList()
      }
    }
  }
</script>


<style lang="scss" scoped>
.con{
  background-color: #fff;
  padding: 10px 10px;
}
</style>
